import React, { useState, useEffect } from "react";
import CookieConsent, { getCookieConsentValue } from "react-cookie-consent";

const CookieConsentBanner = () => {
  const [isCookieAccepted, setIsCookieAccepted] = useState(false);

  useEffect(() => {
    // const consentGiven = getCookieConsentValue();
    const consentGiven = getCookie("userConsent");
    if (consentGiven === "true") {
      setIsCookieAccepted(true);
    }
    else {
      setIsCookieAccepted(false);
    }
  }, []);

  const handleAccept = () => {
    setIsCookieAccepted(true);
  };
  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
    return null;
  };
  return (
    <>
      {!isCookieAccepted && (
        <div style={styles.overlay}>
          <CookieConsent
            location="bottom"
            buttonText="I Agree"
            cookieName="userConsent"
            expires={30}
            cookieSecure={true}
            cookiePath="/"
            style={styles.banner}
            buttonStyle={styles.button}
            onAccept={handleAccept}
            enableDeclineButton={false} 
          >
            This website uses cookies to enhance your experience. Please click I Agree to continue.
          </CookieConsent>
        </div>
      )}
    </>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    zIndex: 9998, 
  },
  banner: {
    position: "fixed",
    bottom: 0,
    left: 0,
    width: "100%",
    backgroundColor: "#ffffff",
    color: "#000",
    textAlign: "center",
    padding: "10px 20px",
    zIndex: 9999, 
  },
  button: {
    backgroundColor: "#007BFF",
    color: "#fff",
    fontSize: "14px",
    padding: "10px 20px",
    border: "none",
    cursor: "pointer",
    borderRadius: "5px",
  },
};

export default CookieConsentBanner;
